module.exports = __webpack_public_path__ + "img/09.53062747.jpg";